module.exports = __webpack_public_path__ + "img/logement-espace-exterieur-grand.42756ff2.png";